import { mutateApi, queryApi } from "src/utils/api/ApiMethods"
import { buildQueryString } from "src/utils/api/query_param_helpers"
import { getCurrentMarinaSlug } from "src/utils/url/parsing/marina"

export const getJobTemplates = (params = {}) => {
  const marinaSlug = getCurrentMarinaSlug()
  const qs = buildQueryString(params)

  return queryApi(`/manage/${marinaSlug}/service/job_templates${qs}`)
}

export const getJobTemplateIds = (params = {}) => {
  const marinaSlug = getCurrentMarinaSlug()
  const qs = buildQueryString(params)

  return queryApi(
    `/manage/${marinaSlug}/service/job_templates/selectable_ids${qs}`
  )
}

export const archiveJobTemplate = (jobTemplateId) => {
  const marinaSlug = getCurrentMarinaSlug()
  return mutateApi({
    url: `/manage/${marinaSlug}/service/job_templates/${jobTemplateId}/archive`,
    method: "POST",
  })
}

export const restoreJobTemplate = (jobTemplateId) => {
  const marinaSlug = getCurrentMarinaSlug()
  return mutateApi({
    url: `/manage/${marinaSlug}/service/job_templates/${jobTemplateId}/restore`,
    method: "POST",
  })
}

export const getWorkOrders = (params = {}) => {
  const marinaSlug = getCurrentMarinaSlug()
  const qs = buildQueryString(params)

  return queryApi(`/manage/${marinaSlug}/service/work_orders${qs}`)
}

export const getWorkOrderIds = (params = {}) => {
  const marinaSlug = getCurrentMarinaSlug()
  const qs = buildQueryString(params)

  return queryApi(
    `/manage/${marinaSlug}/service/work_orders/selectable_ids${qs}`
  )
}
